<template>
  <!-- eslint-disable max-len -->
  <div class="flex flex-col event-guests-access lg:flex-row">
    <div class="z-10 w-full lg:w-3/5">
      <h1 class="mb-4 text-3xl font-semibold">
        Verleih deinen Gästen eine Stimme.
      </h1>
      <div class="mb-8 text-gray-700 content">
        <p class="mb-6">
          Jede Playliste erhält einen eigenen Gästezugang. Teile den Link mit deinen Gästen und lass sie die Playliste mitgestalten.
          Deine Gäste benötigen selbst keinen eigenen Spotify Account weder noch einen Account zu unserem Playlist-Manager.
        </p>
        <p class="mb-6">
          Nachdem deine Gäste ihre lieblings Tracks hinzugefügt haben, werden sie dir in der
          <router-link
            :to="{name: 'event.playlist', params: { id: routeId } }"
            class="text-pink-500"
          >
            Playlist
          </router-link>
          unter Gäste Tracks angezeigt.
        </p>

        <p>
          Damit du trotzdem der Herr der lage bleibst, endscheidest du am ende selbst, welche Gäste Tracks in der Playlist landen.
        </p>
      </div>
      <div class="mb-16 guests-access-field">
        <mj-input-group class="flex flex-no-wrap items-baseline w-3/4">
          <mj-input-field
            id="guestsUrl"
            :value="guestsUrl"
            readonly
          />
          <mj-button
            v-clipboard="guestsUrl"
            v-clipboard:success="clipboardSuccessHandler"
            v-clipboard:error="clipboardErrorHandler"
            class="btn-naked btn-primary btn-input"
          >
            <mj-icon
              src="copy"
              class="w-4 h-4 "
            />
          </mj-button>
        </mj-input-group>
      </div>
      <div
        v-if="hasDeactiveGuestFeature"
        class="deactive-guest-access"
      >
        <mj-button
          class="block mb-3 btn-flat-emphasized"
        >
          Deaktivieren
        </mj-button>
        <small class="block w-4/5 text-gray-700">
          Du kannst deinen Gästezugang jederzeit deaktivieren.
          Eine automatische Deaktivierung erfolgt 24 Stunden nach deinem Event.
        </small>
      </div>
    </div>
    <div class="hidden mx-auto mt-16 md:block lg:mt-0 lg:w-2/5 lg:relative">
      <mj-icon
        src="people-music"
        class="right-0 h-auto people-music lg:absolute"
        proportions="rectangle"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getGuestUrl } from '@/helpers';
import ShareService from '@/services/ShareService';
import FeedbackService from '@/services/FeedbackService';

export default {
  name: 'EventGuestAcess',

  data() {
    return {
      routeId: null,
      hasDeactiveGuestFeature: false,
    };
  },

  computed: {
    ...mapGetters(['guestAccessToken', 'currentEvent']),

    guestsUrl() {
      return getGuestUrl() + this.guestAccessToken;
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.params.id) {
          this.routeId = route.params.id;
        }
      },
    },
  },

  methods: {
    clipboardSuccessHandler({ value, event }) {
      FeedbackService.addCopyToClipboardNotification(event);
      ShareService.viaWhatsapp(value, this.currentEvent.name);
    },

    clipboardErrorHandler({ value }) {
      console.log('error', value);
    },
  },

};

</script>


<style lang="scss" scoped>

.people-music {
  width: 32rem;

  @media(min-width: theme('screens.xl')) {
    width: 38rem;
  }
}

</style>
